import { Phone, MessageCircle, MapPin } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const Contact = () => {
  const { t } = useI18n();

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32 bg-[#0A0A0C] border-t border-zinc-900 overflow-hidden"
    >
      {/* Massive background text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <div className="font-headings text-[28vw] md:text-[20vw] leading-none text-white/[0.025] tracking-tighter">
          CALL
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <div className="font-condensed uppercase text-xs tracking-[0.4em] text-[#E51E1A] mb-4">
            · {t.contact.kicker}
          </div>
          <h2 className="font-headings uppercase text-5xl md:text-7xl lg:text-8xl text-white leading-none">
            {t.contact.title} <span className="text-[#E51E1A]">{t.contact.titleAccent}</span>
          </h2>

          <a
            href="tel:+14175140081"
            data-testid="contact-phone-mega"
            className="mt-12 inline-block font-headings uppercase text-5xl md:text-7xl lg:text-8xl text-white hover:text-[#E51E1A] transition-colors tracking-tight"
          >
            (417) 514-0081
          </a>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
          <ContactCard
            icon={Phone}
            label={t.contact.phone}
            value="(417) 514-0081"
            href="tel:+14175140081"
            testId="contact-phone-card"
          />
          <ContactCard
            icon={MessageCircle}
            label={t.contact.whatsapp}
            value="(417) 514-0081"
            href="https://wa.me/14175140081"
            testId="contact-whatsapp-card"
          />
          <ContactCard
            icon={MapPin}
            label={t.contact.area}
            value={t.contact.areaValue}
            testId="contact-area-card"
          />
        </div>
      </div>
    </section>
  );
};

const ContactCard = ({ icon: Icon, label, value, href, testId }) => {
  const Wrapper = href ? "a" : "div";
  const props = href ? { href, target: href.startsWith("http") ? "_blank" : undefined, rel: "noreferrer" } : {};
  return (
    <Wrapper
      {...props}
      data-testid={testId}
      className="group bg-[#0A0A0C] p-10 hover:bg-[#121215] transition-colors block"
    >
      <Icon className="w-8 h-8 text-[#E51E1A] mb-6" strokeWidth={1.8} />
      <div className="font-condensed uppercase text-xs tracking-[0.3em] text-zinc-500">
        {label}
      </div>
      <div className="mt-2 font-headings uppercase text-white text-2xl md:text-3xl group-hover:text-[#E51E1A] transition-colors">
        {value}
      </div>
    </Wrapper>
  );
};
